module.exports = "/static/pdf/ID-Merchant-Contract.e9c4ab96f6a2d4f5cbca8d3ca8a36b9a.pdf";